import script from "./ProductionCameras.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductionCameras.vue?vue&type=script&setup=true&lang=js"

import "./ProductionCameras.vue?vue&type=style&index=0&id=aa20ef8c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\Code\\ASIC\\MulticaseVue\\MulticaseWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa20ef8c"]])

export default __exports__